import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'fc-input',
    templateUrl: './fc-input.component.html',
    styleUrls: ['./fc-input.component.less'],
    standalone: false
})
export class FcInputComponent {
    @Input() placeholder = '';
    @Input() type: Type = Type.Text;
    @Input() value = '';
    @Input() e2eHook: string;
    @Input() disabled: boolean;
    @Input() maxLength = 524288; // W3C default value

    @Output() onChange = new EventEmitter<string>();
    @Output() onEnter = new EventEmitter<string>();

    public onEnterPressed(input: { value: string }) {
        this.onEnter.emit(input.value);
        if (this.type === Type.Search) {
            input.value = '';
        }
    }
}

enum Type {
    Text = 'text',
    Search = 'search'
}
